import generateLegend from '../../util/d3.legend/d3.legend';

export default function() {
  return {
    scope: {
      data: '=',
      count: '@',
    },
    templateNamespace: 'svg',
    link: Link,
  };
}

function Link(scope, element) {
  scope.$watch(() => scope.data, (data) => {
    if (!data) {
      return;
    }

    const width = angular.element(element[0]).parent().width();
    const options = {
      width,
      height: 30, // Default height of without multiple distributions
      margin: {
        bottom: 20,
        top: 5,
        right: 0,
        left: 0,
      },
      wrapper: 'svg',
      top: 0,
      left: 0,
      isMap: false,
      maxSplit: 4,
      textPadding: {
        top: 15,
        left: 30,
      },
      distributions: +scope.count,
      rowSpacing: 10,
      font: {
        'font-size': '12px',
        'font-weight': 'bold',
        'font-family': 'Arial, Helvetica, sans-serif',
      },
    };

    if (data) {
      generateLegend(element[0], angular.copy(data), options);
    }
  }, true);
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/chartLegend/chartLegend.js
 **/